/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
import { CreatePermissionDtoToJSON, MyPermissionsDtoFromJSON, PermissionDtoFromJSON, UpdatePermissionDtoToJSON, } from '../models/index.js';
/**
 *
 */
export class PermissionsApi extends runtime.BaseAPI {
    /**
     * Create a new permission
     */
    async createRaw(requestParameters, initOverrides) {
        if (requestParameters['createPermissionDto'] == null) {
            throw new runtime.RequiredError('createPermissionDto', 'Required parameter "createPermissionDto" was null or undefined when calling create().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key-header authentication
        }
        let urlPath = `/auth/v1/owner/permissions`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePermissionDtoToJSON(requestParameters['createPermissionDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionDtoFromJSON(jsonValue));
    }
    /**
     * Create a new permission
     */
    async create(createPermissionDto, initOverrides) {
        const response = await this.createRaw({ createPermissionDto: createPermissionDto }, initOverrides);
        return await response.value();
    }
    /**
     * Get all permissions
     */
    async findAllRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key-header authentication
        }
        let urlPath = `/auth/v1/owner/permissions`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PermissionDtoFromJSON));
    }
    /**
     * Get all permissions
     */
    async findAll(initOverrides) {
        const response = await this.findAllRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get current user\'s permissions for a brand
     */
    async getMyPermissionsRaw(requestParameters, initOverrides) {
        if (requestParameters['brandId'] == null) {
            throw new runtime.RequiredError('brandId', 'Required parameter "brandId" was null or undefined when calling getMyPermissions().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/auth/v1/brands/{brandId}/my-permissions`;
        urlPath = urlPath.replace(`{${"brandId"}}`, encodeURIComponent(String(requestParameters['brandId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => MyPermissionsDtoFromJSON(jsonValue));
    }
    /**
     * Get current user\'s permissions for a brand
     */
    async getMyPermissions(brandId, initOverrides) {
        const response = await this.getMyPermissionsRaw({ brandId: brandId }, initOverrides);
        return await response.value();
    }
    /**
     * Update a permission
     */
    async updateRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling update().');
        }
        if (requestParameters['updatePermissionDto'] == null) {
            throw new runtime.RequiredError('updatePermissionDto', 'Required parameter "updatePermissionDto" was null or undefined when calling update().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key-header authentication
        }
        let urlPath = `/auth/v1/owner/permissions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePermissionDtoToJSON(requestParameters['updatePermissionDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionDtoFromJSON(jsonValue));
    }
    /**
     * Update a permission
     */
    async update(id, updatePermissionDto, initOverrides) {
        const response = await this.updateRaw({ id: id, updatePermissionDto: updatePermissionDto }, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=PermissionsApi.js.map